export default "__VITE_ASSET__C8183cZY__"